var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-list"},[_c('h1',[_vm._v("Co bychom si přáli?")]),_c('ul',_vm._l((_vm.gifts),function(gift){return _c('Gift',_vm._b({key:("gift-" + (gift.id))},'Gift',gift,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }